import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { WacPagesMethod, WacPagesRecord } from '../../webAccessControlCustomPagesApp/types';
import { RpcResponse } from '../types';

export class WebAccessControlCustomPagesFormBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'WebAccessControlCustomPages';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async getDataForView() {
    return {};
  }

  public async createRecords(records: Array<WacPagesRecord>): Promise<RpcResponse> {
    return ConsoleRequest.createRequest<RpcResponse>({
      dataProviderType: this.dataProviderType,
      payload: {records: records},
      endpoint: this.endpoint,
      method: WacPagesMethod.CREATE_RECORDS,
    });
  }

  public async updateRecords(records: Array<WacPagesRecord>): Promise<RpcResponse> {
    return ConsoleRequest.createRequest<RpcResponse>({
      dataProviderType: this.dataProviderType,
      payload: {records: records},
      endpoint: this.endpoint,
      method: WacPagesMethod.UPDATE_RECORDS,
    });
  }

  public async getSuggestedFieldValue(): Promise<string> {
    return ConsoleRequest.createRequest<string>({
      dataProviderType: this.dataProviderType,
      payload: {companyId: Application.Main.getActiveCompany().id},
      endpoint: this.endpoint,
      method: WacPagesMethod.GET_SUGGESTED_NAME,
    });
  }

}
